import { injectBaseConstantMethods } from "./BaseConstants"

const ProductionLineStatus = {
   Active: "ACTIVE",
   Inactive: "INACTIVE",
}

const displayTextKeys = {
   [ProductionLineStatus.Active]: "Active",
   [ProductionLineStatus.Inactive]: "Inactive",
}

const labelClass = {
   [ProductionLineStatus.Active]: "bg-green-req",
   [ProductionLineStatus.Inactive]: "bg-red-req",
}

export default injectBaseConstantMethods(
   ProductionLineStatus,
   displayTextKeys,
   labelClass
)
